import { PasswordInput, TextInput } from "@tblabs/truffle";
import { Page } from "../../Pages/Product/Page";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";
import { InfoBox } from "../../Pages/Product/InfoBox";
import { LoginFormLogic } from "./LoginFormLogic";


export class LoginPage extends Page
{
    constructor(private _formLogic: LoginFormLogic)
    {
        super("Logowanie", "admin-page");

        this.body.Style(`margin-top: 64px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;`)
    }

    protected async OnAppend(): Promise<void>
    {
        if (this._formLogic.IsAuthorized)
        {
            this.body.Append(
                new InfoBox("Jesteś już zalogowany", `Jako ${this._formLogic.User.Name}`),
                new PrimaryButton("Wyloguj").WidthAuto().OnClick(() => this._formLogic.Logout())
            );
            return;
        }

        const loginInput = new TextInput(this._formLogic.LoginInput).Color("#fff").WidthAuto().BorderRadius(4)
            .Placeholder("Login")
            .OnEnterKeyPressed(async () => await this._formLogic.TryLogin())

        const passwordInput = new PasswordInput(this._formLogic.PasswordInput).Color("#fff").StyleInput(`border-radius: 4px;`)
            .TogglePasswordView()
            .Placeholder("Hasło")
            .OnEnterKeyPressed(async () => await this._formLogic.TryLogin())

        const loginButton = new PrimaryButton("Zaloguj").WidthAuto().Padding(8, 24).FontNormal().BorderRadius(4).FontSize(16)
            .Disable(this._formLogic.LoginInProgress)
            .OnClick(async () => await this._formLogic.TryLogin())

        this.body.Append(
                loginInput,
                passwordInput,
                loginButton,
                new InfoBox("Błąd", this._formLogic.ErrorMessage)
                    .Visible(this._formLogic.ErrorMessageVisible),
        );
    }
}